import { BooleanOptions, Options } from "../../../components/Select";
import { InvestmentsHistoryResponse } from "../../../services";

export const EMPTY_HISTORY: Omit<InvestmentsHistoryResponse, "range"> = {
  data: [],
  summary: {
    currentValue: 0,
    investedValue: 0,
    changeValue: 0,
    changePercent: null,
    valuation: { state: "AVAILABLE", reason: null, asOf: null },
  },
  byInvestment: [],
};

export const ACTIVE_OPTIONS: BooleanOptions[] = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const YEAR_OPTIONS: Options[] = [
  {
    label: new Date().getFullYear().toString(),
    value: new Date().getFullYear(),
  },
];

// Hero trend chart height per breakpoint. Shared by the Hero, its empty-state
// placeholder and the skeleton so all three reserve the same vertical space and
// the page never shifts as data loads in.
export const HERO_CHART_HEIGHT = {
  compact: 280,
  regular: 360,
};
